import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from 'react-router';
import { addFileMetaDataCategory } from '../../../actions/fileData';
import {TabContent, TabPane, Button, Form, FormGroup, Label, Input, FormText, Card, CardBody, CardTitle, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import FileMetaDataValues from '../Metadatavalues'


class FileMetaDataForm extends Component {

    constructor(props,context) {
        super(props,context);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {postData: false, edit: false, 'fileMetaData': false, 'activeTab' : '1'}
        this.toggle = this.toggle.bind(this);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    componentWillMount()
    {

        if(this.props.match.params.categoryid)
        {
            const categoryId = this.props.match.params.categoryid;

            const category = this.props.fileMetaData.data.find(e => e.id === categoryId);

            this.setState({'edit': true, 'postData': category, 'fileMetaData': category})


        }
    }

    handleSubmit(e) {
        e.preventDefault();

        this.props.addFileMetaDataCategory(
            this.props.clientPath.clientPath,
            this.state.postData,
        );
    }

    setInputState(e) {
      this.setState({
          postData: {...this.state.postData, [e.target.name]: e.target.value }

      });
    }

    setCheckedValue(e) {
        this.setState({
            postData: {...this.state.postData, [e.target.name]: e.target.checked ? 1 : 0 }
        })
    }



    render() {
        return (
        <div className="animated fadeIn">
                <Card>
                    <CardBody>
                        <CardTitle><i className="fa fa-file"></i> Metadata categorie {this.state.edit ? 'bewerken' : 'toevoegen'}</CardTitle>
                        <Form onSubmit={(e) => this.handleSubmit(e)}>
                            <FormGroup>
                                <Label for="name">Metadata</Label>
                                <Input type="text" defaultValue={this.state.fileMetaData ? this.state.fileMetaData.name : null} onChange={(e) => this.setInputState(e)} name="name" id="name" placeholder="Metadata" />
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="is_searchable">
                                    <Input type="checkbox"  defaultChecked={this.state.fileMetaData && this.state.fileMetaData.is_searchable === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_searchable" id="is_searchable" />
                                    &nbsp; Is zoekbaar?
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="is_text">
                                    <Input type="checkbox"  defaultChecked={this.state.fileMetaData && this.state.fileMetaData.is_text === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_text" id="is_text" />
                                    &nbsp; Is een vrij invoerveld?
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="is_date">
                                    <Input type="checkbox"  defaultChecked={this.state.fileMetaData && this.state.fileMetaData.is_date === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_date" id="is_date" />
                                    &nbsp; Is een datumveld?
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="is_unique">
                                    <Input type="checkbox"  defaultChecked={this.state.fileMetaData && this.state.fileMetaData.is_unique === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_unique" id="is_unique" />
                                    &nbsp; Heeft een unieke waarde?
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="is_active">
                                    <Input type="checkbox" defaultChecked={this.state.fileMetaData && this.state.fileMetaData.is_active === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="is_active" id="is_active" />
                                     &nbsp; Is actief?
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check for="in_reports">
                                    <Input type="checkbox" defaultChecked={this.state.fileMetaData && this.state.fileMetaData.in_reports === '1' ? 'checked' : false} onChange={(e) => this.setCheckedValue(e)} name="in_reports" id="in_reports" />
                                    &nbsp; Beschikbaar voor rapportages?
                                </Label>
                            </FormGroup>
                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-dot-circle-o"></i> {this.state.edit ? 'Bijwerken' : 'Toevoegen'}</button>
                        </Form>
                    </CardBody>
                </Card>
                {this.state.fileMetaData ?
                   <FileMetaDataValues data={this.state.fileMetaData.values} />
                : ''}

        </div>
        )
    }
}


function mapStateToProps(state, ownProps) {

    return {
        fileMetaData: state.FileMetaDataCategoryReducer,
        clientPath: state.clientPathReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFileMetaDataCategory: (url, postData) => dispatch(addFileMetaDataCategory(url, postData))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileMetaDataForm))



// WEBPACK FOOTER //
// ./src/views/Filemetadatacategory/Form/index.js